export default "__VITE_ASSET__244807b1__"